import axios from "axios";
import {API_HOST} from "@/core/variables";
import {WorkspaceUpdateImportantRequest} from "@/query/workspace/useUpdateWorkspaceImportant";

class WorkspaceRepository {
    async find(props:{page: number, size?: number, searchType?: SearchType, searchKeyword?: string, deleted?: boolean,
               important?: boolean, userId?: string}) {
        return axios.get(`${API_HOST}/v1/workspaces`, {
            params: props
        });
    };

    async read(workspaceId: string) {
        return axios.get(`${API_HOST}/v1/workspaces/${workspaceId}`);
    };

    async updateImportant(workspaceId: string, body: WorkspaceUpdateImportantRequest) {
        return axios.put(`${API_HOST}/v1/workspaces/${workspaceId}`, body);
    }

    async findSubscriptionHistories(workspaceId: string) {
        return axios.get(`${API_HOST}/v1/subscription-histories/${workspaceId}`);
    }

    async readWorkspaceCard(workspaceId: string) {
        return axios.get(`${API_HOST}/v1/workspace-card/${workspaceId}`)
    }

    async deleteWorkspace(workspaceId: string) {
        return axios.delete(`${API_HOST}/v1/workspaces/${workspaceId}`)
    }

    async hardDeleteWorkspace(workspaceId: string) {
        return axios.delete(`${API_HOST}/v1/workspaces/${workspaceId}/hard-delete`)
    }

    async restoreWorkspace(workspaceId: string) {
        return axios.put(`${API_HOST}/v1/workspaces/${workspaceId}/restore`)
    }
}

export enum SearchTypeEnum {
    WORKSPACENAME = 'workspace_name',
    USEREMAIL = 'user_email',
}

export type SearchType = SearchTypeEnum.WORKSPACENAME | SearchTypeEnum.USEREMAIL

export const isSearchType = (text?: unknown): text is SearchType => {
    return (text === SearchTypeEnum.WORKSPACENAME || text === SearchTypeEnum.USEREMAIL)
}
const workspaceRepository = new WorkspaceRepository();

export default workspaceRepository;
